/**
 * The built-in sketch-object types whose drawing is pure data, as
 * ObjectDefinitionSpecs — exact twins of the code types in the client
 * (checked there against the built-ins). Shared so the server can hand them
 * to the object-generating AI as worked examples; the client adds the
 * SVG-based ones (chair, bath, shower, desk, table).
 */

import type { ObjectDefinitionSpec } from '../spec';
import { baseCabinetSpec } from './baseCabinet';
import { beamSpec } from './beam';
import { bedSpec } from './bed';
import { columnSpec } from './column';
import { radiatorSpec } from './radiator';
import { sinkSpec } from './sink';
import { stairSpec } from './stair';
import { stairLSpec } from './stairL';
import { stairSpiralSpec } from './stairSpiral';
import { stairUSpec } from './stairU';
import { toiletSpec } from './toilet';

export { baseCabinetSpec, beamSpec, bedSpec, columnSpec, radiatorSpec, sinkSpec, stairLSpec, stairSpec, stairSpiralSpec, stairUSpec, toiletSpec };

/** Built-in type id → its data spec (the pure-data built-ins). */
export const DATA_BUILTIN_OBJECT_SPECS: Readonly<Record<string, ObjectDefinitionSpec>> = {
  stair: stairSpec,
  stair_l: stairLSpec,
  stair_u: stairUSpec,
  stair_spiral: stairSpiralSpec,
  base_cabinet: baseCabinetSpec,
  radiator: radiatorSpec,
  toilet: toiletSpec,
  sink: sinkSpec,
  bed: bedSpec,
  column: columnSpec,
  beam: beamSpec,
};

export { bifoldDoorSpec, DATA_BUILTIN_DOOR_SPECS, DATA_BUILTIN_WINDOW_SPECS, doubleDoorSpec, openDoorwaySpec, singleDoorSpec, standardWindowSpec } from './openings';

export { DATA_BUILTIN_DIMENSION_SPECS, DEFAULT_DIMENSION_TYPE_ID, dimensionSpec } from './dimensions';
